<button
  (mousedown)="$event.preventDefault()"
  (throttledClick)="!isDisabled() && !isLoading() && handleClick.emit($event)"
  [throttleTime]="1000"
  class="button primary-button w-full border border-[#D5D7DA!important] rounded-[0.5rem] px-[1.2rem] whitespace-nowrap flex flex-row items-center justify-center {{type()}}"
  [class.disabled]="isDisabled()"
  [class.loading]="isLoading()"
  [class.opacity-40]="isDisabled()"
  [disabled]="isLoading() || isDisabled()"
  preventMultipleClick
>
  @if (!isLoading()) {
    <div
      class="button-content  w-full truncate"
    >
      <ng-content/>
    </div>
  } @else {
    <mat-spinner
      class="button-loader"
      mode="indeterminate"
      [diameter]="20"
    >
    </mat-spinner>
  }

  <div [id]="buttonId()" class="overlay"></div>
</button>
